import { KbArticleStub, KbCategory, KbSection } from '@evidentid/tprm-portal-lib/models/kb';

/** Articles sharing at least one content tag with `articleId`, ranked by shared-tag count
 * (most first). Ties keep tree order: depth-first, an article's own section's articles
 * before its subsections, each level by position. The article itself is excluded. An
 * article with no tags, or one that isn't in the tree, has no related articles.
 */
export function findRelatedArticles(tree: KbCategory[], articleId: string, limit = 5): KbArticleStub[] {
    const all: KbArticleStub[] = [];
    const collect = (sections: KbSection[]): void => {
        for (const section of [ ...sections ].sort((a, b) => a.position - b.position)) {
            all.push(...[ ...section.articles ].sort((a, b) => a.position - b.position));
            collect(section.sections);
        }
    };
    for (const category of [ ...tree ].sort((a, b) => a.position - b.position)) {
        collect(category.sections);
    }

    const tags = new Set(all.find((article) => article.id === articleId)?.contentTagIds ?? []);
    if (!tags.size) {
        return [];
    }

    return all
        .filter((article) => article.id !== articleId)
        .map((article, order) => ({
            article,
            order,
            shared: (article.contentTagIds ?? []).filter((tag) => tags.has(tag)).length,
        }))
        .filter(({ shared }) => shared > 0)
        .sort((a, b) => b.shared - a.shared || a.order - b.order)
        .slice(0, limit)
        .map(({ article }) => article);
}
